var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"at-empty-conversation"},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.TRANS.search_results))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"at-chatloader"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }